import { apiService, AppConstants, Interfaces, Models, Utils } from "@/core/Export";
import VueI18n from "@/i18n";
import store from '@/store';
import { date, Quasar } from "quasar";
import router from "../router";

export default class AppEnv {
  appStorage: appStorage;
  isErrorDialogVisible: boolean;
  isInfoDialogVisible: boolean;
  infoDialogPromiseResolve: Function;
  errorDialogMsgs: Array<any>;
  infoDialogMsgs: Array<any>;
  isBusy: boolean;
  screenTitle: string = null;
  private _autenticated: boolean;
  private _userInfo: Models.UserInfo;
  customerCode: string;
  device: any;
  cordovaVersionNo: string;
  isEmpApprovalsListDialogVisible: boolean;
  isManagerApprovalsListDialogVisible: boolean;
  isDisplayMsgsInLogin: boolean;
  isReportBusy: boolean;

  constructor() {
    this.appStorage = new appStorage();
    this.isErrorDialogVisible = false;
    this.isInfoDialogVisible = false;
    this.infoDialogPromiseResolve = () => { };
    this.errorDialogMsgs = new Array<any>();
    this.infoDialogMsgs = new Array<any>();
    this.isBusy = false;
    this.customerCode = null;
    this.device = null;
    this.cordovaVersionNo = "";
    this.isEmpApprovalsListDialogVisible = false;
    this.isManagerApprovalsListDialogVisible = false;
    this.isDisplayMsgsInLogin = false;
    this.isReportBusy = false;
  }

  showNotificationInfo($q, headerInfoMessage, informationMessage) {
    $q.notify({
      message: `${this.translate(headerInfoMessage)} - ${informationMessage}`,
      timeout: 4000,
      textColor: 'white',
      color: "primary",
      actions: [
        { label: this.translate('close').toString(), color: 'white', handler: () => { } }
      ]
    })
  }

  onResetIsFillTeken(day: Models.EAME_DayDto, lines: Array<Models.EAME_PairDto>, line: Models.EmployeePairsEntry, specialEvents: Array<any>) {
    let isFillTekenVisible = this.isFillTekenVisible(day, lines, line, specialEvents);
    if (!isFillTekenVisible) line.isFillTeken = false;
  }

  isFillTekenVisible(day: Models.EAME_DayDto, lines: Array<Models.EAME_PairDto>, line: Models.EmployeePairsEntry, specialEvents: Array<any>) {
    if (line.hasOwnProperty("pairs")) {
      if (day.pairs.length > 0) return false;
    } else {
      let currentLineIndex = lines.indexOf(line);
      if (currentLineIndex + 1 != lines.length) return false;

      let lineWithoutEntryOrExitIndex = lines.indexOf(lines.find(q => (!q.entryLog.timeText || !q.exitLog.timeText)));
      if (currentLineIndex != lineWithoutEntryOrExitIndex) return false;

      if (!line.entryLog.timeText && !line.exitLog.timeText) return false;
    }

    let specialEvent = null;
    if (line.attendSpecialEventId > 0) specialEvent = specialEvents.find(q => q.id == line.attendSpecialEventId);
    return this.isAllowed(AppConstants.Permissions.AttendSpecialActivity) && specialEvent && specialEvent.addField1 && line.missingEventId <= 0 && ((!line.entryLog.timeText && !line.exitLog.timeText) || (line.entryLog.timeText && !line.exitLog.timeText));
  }

  onFlipEntryExit(line: Models.EmployeePairsEntry) {
    let entryLog = line.entryLog;
    let exitLog = line.exitLog;

    if (entryLog.stateCode == AppConstants.EntryExitLogStates.Approved || exitLog.stateCode == AppConstants.EntryExitLogStates.Approved) return;

    let isEntryManual = Boolean(entryLog.isManualEntry && entryLog.timeText);
    let isExitManual = Boolean(exitLog.isManualEntry && exitLog.timeText);
    if (isEntryManual && isExitManual) return;

    let isPunchIn = Boolean(!line.entryLog.isManualEntry && line.entryLog.timeText && line.entryLog.sourceCode == AppConstants.AttendEntrySource.Portal);
    let isPunchOut = Boolean(!line.exitLog.isManualEntry && line.exitLog.timeText && line.exitLog.sourceCode == AppConstants.AttendEntrySource.Portal);
    if (isPunchIn && isPunchOut) return;

    line.entryLog = exitLog;
    line.exitLog = entryLog;

    line.isEntryFliped = !line.isEntryFliped;
  }

  canFlipEntryExit(line: Models.EmployeePairsEntry) {
    if (line.entryLog.stateCode == AppConstants.EntryExitLogStates.Approved || line.exitLog.stateCode == AppConstants.EntryExitLogStates.Approved) return false;

    let isEntryManual = Boolean(line.entryLog.isManualEntry && line.entryLog.timeText);
    let isExitManual = Boolean(line.exitLog.isManualEntry && line.exitLog.timeText);
    if (isEntryManual && isExitManual) return false;

    let isPunchIn = Boolean(!line.entryLog.isManualEntry && line.entryLog.timeText && line.entryLog.sourceCode == AppConstants.AttendEntrySource.Portal);
    let isPunchOut = Boolean(!line.exitLog.isManualEntry && line.exitLog.timeText && line.exitLog.sourceCode == AppConstants.AttendEntrySource.Portal);
    if (isPunchIn && isPunchOut) return false;

    return (line.entryLog.id > 0 || line.exitLog.id > 0) && (line.missingEventId <= 0);
  }

  canEditEntryOrExit(entryExitLog: Models.EmployeeEntryExitLog) {
    return (entryExitLog.isManualEntry && (!entryExitLog.sourceCode || entryExitLog.sourceCode == AppConstants.AttendEntrySource.Portal) && (!entryExitLog.stateCode || entryExitLog.stateCode == AppConstants.EntryExitLogStates.To_Approve));
  }

  canEditEntry(line: Models.EmployeePairsEntry) {
    let IsManagerPermission = this._userInfo.employeeId == this.currentEmployee.id;
    if (!IsManagerPermission && this.isAllowed(AppConstants.Permissions.PortalManagerEditOnlyComment)) {
      return !this.isAllowed(AppConstants.Permissions.PortalManagerEditOnlyComment)
    }
    if (line.entryLog.stateCode == AppConstants.EntryExitLogStates.To_Approve) {
      return line.missingEventId <= 0 && this.isAllowed(AppConstants.Permissions.AttendUpdateToApprove);
    } else if (line.entryLog.stateCode == AppConstants.EntryExitLogStates.Lock || line.entryLog.stateCode == AppConstants.EntryExitLogStates.Approved) {
      let permission = this._userInfo.employeeId == this.currentEmployee.id ? AppConstants.Permissions.PortalEmployeeEditClockAppPhonesData : AppConstants.Permissions.PortalManagerEditClockAppPhonesData;
      return line.missingEventId <= 0 && this.isAllowed(permission);
    }
    return line.missingEventId <= 0 && this.canEditEntryOrExit(line.entryLog);
  }

  get currentEmployee() {
    return store.getters.currentEmployee;
  }


  canEditExit(line: Models.EmployeePairsEntry) {
    let IsManagerPermission = this._userInfo.employeeId == this.currentEmployee.id;
    if (!IsManagerPermission && this.isAllowed(AppConstants.Permissions.PortalManagerEditOnlyComment)) {
      return !this.isAllowed(AppConstants.Permissions.PortalManagerEditOnlyComment)
    }
    if (line.exitLog.stateCode == AppConstants.EntryExitLogStates.To_Approve) {
      return line.missingEventId <= 0 && this.isAllowed(AppConstants.Permissions.AttendUpdateToApprove);
    } else if (line.exitLog.stateCode == AppConstants.EntryExitLogStates.Lock || line.exitLog.stateCode == AppConstants.EntryExitLogStates.Approved) {
      let permission = this._userInfo.employeeId == this.currentEmployee.id ? AppConstants.Permissions.PortalEmployeeEditClockAppPhonesData : AppConstants.Permissions.PortalManagerEditClockAppPhonesData;
      return line.missingEventId <= 0 && this.isAllowed(permission);
    }
    return line.missingEventId <= 0 && this.canEditEntryOrExit(line.exitLog);
  }

  inHealthDeclarationIsVisible(entryExitLog: Models.EmployeeEntryExitLog) {
    let recordDate = Date.parse(entryExitLog.date);
    let todayDate = Date.parse(new Date(new Date().setHours(0, 0, 0, 0)).toISOString());
    return entryExitLog.missingEventId == 0 && recordDate <= todayDate;
  }

  isToApproveForView(stateCode) {
    return stateCode == AppConstants.EntryExitLogStates.To_Approve;
  }

  isApproveForView(stateCode) {
    return stateCode == AppConstants.EntryExitLogStates.Approved;
  }

  isToApproveForEditing(entryExitLog: Models.EmployeeEntryExitLog) {
    return (
      entryExitLog.timeText &&
      entryExitLog.stateCode == AppConstants.EntryExitLogStates.To_Approve
    );
  }

  isApproveForEditing(entryExitLog: Models.EmployeeEntryExitLog) {
    return (
      entryExitLog.timeText &&
      entryExitLog.stateCode == AppConstants.EntryExitLogStates.Approved
    );
  }

  getEntryExitColor(entryExitLog: Models.EmployeeEntryExitLog) {
    if (entryExitLog.sourceCode == AppConstants.AttendEntrySource.Application) {
      return "negative";
    } else if (
      entryExitLog.sourceCode == AppConstants.AttendEntrySource.Portal
    ) {
      return "blue";
    } else {
      return "black";
    }
  }

  getEntryExitColorForView(sourceCode: string, isFillTeken: boolean) {
    if (sourceCode == AppConstants.AttendEntrySource.Application) {
      return "negative";
    } else if (sourceCode == AppConstants.AttendEntrySource.Portal) {
      return "blue";
    } if (isFillTeken) {
      return "positive";
    } else {
      return "black";
    }
  }

  getEventColor(entrySourceCode: string) {
    if (entrySourceCode == AppConstants.AttendEntrySource.Application) {
      return "text-negative";
    } else if (entrySourceCode == AppConstants.AttendEntrySource.Portal) {
      return "text-blue";
    } else {
      return null;
    }
  }

  public onCheckApiUrlByCustomerCode(customerCode: string): Promise<any> {
    this.isBusy = true;
    this.customerCode = customerCode;

    return apiService
      .checkApiUrlByCustomerCode(this.customerCode)
      .then((res) => {
        let customerApiUrl = res;
        if (customerApiUrl) {
          customerApiUrl = `${customerApiUrl}/api`;
          this.setApiBaseUrl(customerApiUrl);
        } else {
          this.setApiBaseUrl(AppConstants.Http.CommonBaseUrl);
        }
        this.isBusy = false;
        return Promise.resolve();
      })
      .catch((err) => {
        this.isBusy = false;
        return Promise.resolve();
      });
  }

  private setApiBaseUrl(url: string): void {
    window["appSettings"].BaseUrl = url;
    AppConstants.Http.BaseUrl = url;
  }

  public getReport(model, fileExt) {
    this.isBusy = true;
    this.isReportBusy = true;
    if (!model.employeeId) model.employeeId = 0;
    if (!model.orgStructId) model.orgStructId = 0;
    return apiService
      .getUserReportKey(model.reportTypeCode, {
        employeeIds: model.employeeIds,
        orgStructId: model.orgStructId,
        year: model.year ? model.year : -1,
        month: model.month ? model.month : -1,
        salaryFactoryNo: model.salaryFactoryNo,
        fromDate: model.fromDate,
        toDate: model.toDate,
        layoutId: model.layoutId ? model.layoutId : 0,
        dynamicReportId: model.dynamicReportId ? model.dynamicReportId : 0,
        sortBy: model.sortBy ? model.sortBy : 0,
        thenBy: model.thenBy ? model.thenBy : 0,
        dynamicSortBy: model.dynamicSortBy ? model.dynamicSortBy : "",
        dynamicThenBy: model.dynamicThenBy ? model.dynamicThenBy : "",
        dataHoursOrDays: model.dataHoursOrDays
      })
      .then(res => {
        let call = res.calls[0];
        if (call && call.isSuccess) {
          let userReportRequestResult = call.callResult.data;
          if (userReportRequestResult.isHandleByQueue) {
            this.showReportEnterToQueueMessage();
          } else {
            let reportKey = userReportRequestResult.key;
            return this.getReportUrl(reportKey, fileExt).then((url) => url);
          }
        } else {
          this.showErrorDialog(call.msgs.msgs);
          this.isBusy = false;
          this.isReportBusy = false;
        }
      })
      .catch(err => {
        this.isBusy = false;
        this.isReportBusy = false;
      });
  }

  public showReportEnterToQueueMessage() {
    this.isBusy = false;
    let msg = this.translate("reportEnterToQueue").toString();
    let timeout = 7000;
    Utils.Notification.notifyPositive(msg, "check_circle", "bottom", timeout);
    setTimeout(() => {
      this.isReportBusy = false;
    }, timeout);
  }


  private getReportUrl(reportKey: string, fileExt: string, isReportPreparedFile: boolean = false) {
    return apiService
      .getReportUrl(reportKey, fileExt)
      .then(res => {
        let fileUrl = '';
        if (res) {
          if (this.IsMobileApp) {
            this.saveBlobToFile("report." + fileExt, res);
          } else {
            fileUrl = window.URL.createObjectURL(res) + "#view=Fit";
          }
        }
        this.isBusy = false;
        this.isReportBusy = false;
        return fileUrl;
      })
      .catch(err => {
        this.isBusy = false;
        this.isReportBusy = false;
      });
  }

  saveBlobToFile(fileName, blob) {
    let windowAny = window as any;
    var folder = "";
    console.log(`Device Is = ${this.device.platform}`);
    if (this.device.platform == "Android") {
      console.log(`Cordova File JSON = ${JSON.stringify(window["cordova"].file)}`);
      folder = `${window["cordova"].file.externalDataDirectory}`;
    } else if (this.device.platform == "iOS") {
      folder = window["cordova"].file.documentsDirectory;
    }

    windowAny.resolveLocalFileSystemURL(folder, (dirEntry) => {
      console.log('resolveLocalFileSystemURL', JSON.stringify(dirEntry));
      this.createFile(dirEntry, fileName, blob);
    }, this.onErrorLoadFs);
  }

  createFile(dirEntry, fileName, blob) {
    // Creates a new file
    dirEntry.getFile(fileName, { create: true, exclusive: false }, (fileEntry) => {
      this.writeFile(fileEntry, blob)
    }, this.onErrorCreateFile)
  }

  writeFile(fileEntry, blob) {
    // Create a FileWriter object for our FileEntry
    fileEntry.createWriter((fileWriter) => {
      fileWriter.onwriteend = () => {
        console.log('Successful file write...');
        this.openFile(fileEntry, blob.type);
      }

      fileWriter.onerror = (error) => {
        console.log('Failed file write: ' + error);
      }

      fileWriter.write(blob);
    })
  }

  openFile(fileEntry, mimType) {
    console.log(fileEntry);
    window["cordova"].plugins.fileOpener2.showOpenWithDialog(`${fileEntry.nativeURL}`, `${mimType}`, {
      error: (e) => {
        console.log('Error status: ' + e.status + ' - Error message: ' + e.message);
      },
      success: () => {
        console.log('file opened successfully');
      },
      position: [0, 0]
    }
    );
  }

  onErrorLoadFs(error) {
    console.log("onErrorLoadFs", JSON.stringify(error));
  }

  onErrorCreateFile(error) {
    console.log("onErrorCreateFile", JSON.stringify(error));
  }

  toUTC(value: string) {
    let extract = this.extractDate(value);
    return new Date(
      Date.UTC(extract.getFullYear(), extract.getMonth(), extract.getDate())
    );
  }

  formatDate(value: string, hasTime: boolean = false, removeYear: boolean = false) {
    if (value) {
      if (hasTime) {
        return date.formatDate(value, "DD/MM/YYYY, HH:mm");
      } else {
        if (removeYear) {
          return date.formatDate(value, "DD/MM");
        } else {
          return date.formatDate(value, "DD/MM/YYYY");
        }
      }
    }
  }

  extractDate(value: string) {
    if (value) {
      return date.extractDate(value, "DD/MM/YYYY");
    }
  }

  formatHour(value: string) {
    if (value) {
      return date.formatDate(value, "HH:mm");
    }
  }

  onSetAttendEditNotesFieldError(dayOrPair, attendWithOutRemark, notSignReasons) {
    if ((this.canEditEntry(dayOrPair) && this.hasLogValue(dayOrPair, true)) || (this.canEditExit(dayOrPair) && this.hasLogValue(dayOrPair, false))) {
      let isEntryNotSignReasonRequiredComment = false;
      if (dayOrPair.entryLog.notSingingReasonId > 0) {
        isEntryNotSignReasonRequiredComment = notSignReasons.find(q => q.id == dayOrPair.entryLog.notSingingReasonId).addField1; // isForceComment
      }

      let isExitNotSignReasonRequiredComment = false;
      if (dayOrPair.exitLog.notSingingReasonId > 0) {
        isExitNotSignReasonRequiredComment = notSignReasons.find(q => q.id == dayOrPair.exitLog.notSingingReasonId).addField1; // isForceComment
      }

      if (isEntryNotSignReasonRequiredComment || isExitNotSignReasonRequiredComment) {
        dayOrPair.hasNotesError = !dayOrPair.notes || this.checkStringTavim(dayOrPair.notes);
      } else if (!attendWithOutRemark && (!dayOrPair.notes || this.checkStringTavim(dayOrPair.notes))) {
        dayOrPair.hasNotesError = !attendWithOutRemark && (!dayOrPair.notes || this.checkStringTavim(dayOrPair.notes));
        if ((dayOrPair.entryLog.stateCode == AppConstants.EntryExitLogStates.Approved || dayOrPair.entryLog.stateCode == AppConstants.EntryExitLogStates.Lock) &&
          (dayOrPair.exitLog.stateCode == AppConstants.EntryExitLogStates.Approved || dayOrPair.exitLog.stateCode == AppConstants.EntryExitLogStates.Lock)) {
          dayOrPair.hasNotesError = false;
        }
      } else {
        dayOrPair.hasNotesError = false;
      }
    }
    else {
      dayOrPair.hasNotesError = false;
    }
  }

  checkStringTavim(str: string) {
    if (/^[\/""!@#$%^&*{}\[\],:\\|.\s]+$/g.test(str)) {
      return true;
    }
    else {
      return false;
    }

  }

  hasLogValue(dayOrPair: any, isEntry: boolean): boolean {
    if (isEntry) {
      return !(dayOrPair.entryLog.timeText == "" || dayOrPair.entryLog.timeText == null);
    } else {
      return !(dayOrPair.exitLog.timeText == "" || dayOrPair.exitLog.timeText == null);
    }
  }

  onSetAttendSpecialEventFieldError(dayOrPair): void {
    if (this._userInfo.forceSpecialEvent && dayOrPair.attendSpecialEventId <= 0 && (this.hasLogValue(dayOrPair, true) || this.hasLogValue(dayOrPair, false))) {
      dayOrPair.hasSpecialEventRequiredError = true;
    }
    else {
      dayOrPair.hasSpecialEventRequiredError = false;
    }
  }

  onSetEntryNotSingingReasonErrorFieldError(dayOrPair, isNotSingingReasonRequired) {
    if (isNotSingingReasonRequired) {
      if (this.canEditEntry(dayOrPair) && dayOrPair.entryLog.isManualEntry) {
        dayOrPair.hasEntryNotSingingReasonError = dayOrPair.missingEventId === 0 && dayOrPair.entryLog.timeText && dayOrPair.entryLog.notSingingReasonId === 0;
      } else {
        dayOrPair.hasEntryNotSingingReasonError = false;
      }

      if (this.canEditExit(dayOrPair) && dayOrPair.exitLog.isManualEntry) {
        dayOrPair.hasExitNotSingingReasonError = dayOrPair.missingEventId === 0 && dayOrPair.exitLog.timeText && dayOrPair.exitLog.notSingingReasonId === 0;
      } else {
        dayOrPair.hasExitNotSingingReasonError = false;
      }
    } else {
      dayOrPair.hasEntryNotSingingReasonError = false;
      dayOrPair.hasExitNotSingingReasonError = false;
    }
  }

  navigate(route) {
    if (route) {
      router.push(route);
    }
  }

  translate(caption) {
    return VueI18n.t(caption);
  }

  showErrorDialog(msgs: Array<any>) {
    this.errorDialogMsgs = msgs;
    this.isErrorDialogVisible = true;
  }

  showInfoDialog(msgs: Array<string>): Promise<void> {
    return new Promise((resolve) => {
      this.infoDialogMsgs = msgs;
      this.isInfoDialogVisible = true;
      this.infoDialogPromiseResolve = resolve;
    });
  }

  async setAdditionalJob(selectedEmpAdditionalJobId: number) {
    try {
      if (selectedEmpAdditionalJobId == 0) return;

      this.isBusy = true;
      let result: Interfaces.iServiceRequest = await apiService.getUserInfoAdditionalJob(selectedEmpAdditionalJobId);
      let call = result.calls[0] as Interfaces.iServiceCall;
      if (call && call.isSuccess) {
        let userInfo = call.callResult.data as Models.UserInfo;
        let employeeId = userInfo.employeeId;
        let displayName = userInfo.displayName;

        this._userInfo.approvals = userInfo.approvals;
        this._userInfo.actingManagers = userInfo.actingManagers;
        this._userInfo.isManager = userInfo.isManager;
        this._userInfo.employeeId = employeeId;
        this._userInfo.displayName = displayName;
        this._userInfo.additionalJobs = userInfo.additionalJobs;
        this._userInfo.primaryEmployeeId = userInfo.primaryEmployeeId;
        store.commit(AppConstants.StoreMutations.UpdateCurrentActingEmployeeId, employeeId);
        this.setApprovlas();
        this.setAdditionalJobs();
        this.setActingManagers();
        this.navigateUserByRole();
        this.openApprovalsDialog();
        store.commit(AppConstants.StoreMutations.UpdateSelectedEmpAdditionalJobId, 0);
        store.commit(AppConstants.StoreMutations.UpdateCurrentEmployee, { id: employeeId, displayName: displayName });

        let key = store.getters.employeeAdditionalJobKey + 1;
        store.commit(AppConstants.StoreMutations.UpdateEmployeeAdditionalJobKey, key);
      } else {
        this.showErrorDialog(call.msgs.msgs);
      }
    } catch (error) {
    } finally {
      this.isBusy = false;
    }
  }


  login(result: any) {
    this._userInfo = result as Models.UserInfo;
    this.appStorage.persist("AppUsername", this._userInfo.displayName);
    this.appStorage.persist("AppPassword", this._userInfo.accessToken);
    this.Authenticated = true;
    this.setLangForUser();
  }

  setLangForUser() {
    let qLangToImport = this._userInfo.langCode;
    if (qLangToImport == "en") qLangToImport = "en-us";

    import(`quasar/lang/${qLangToImport}`)
      .then(qLang => {
        AppConstants.Lang.current = this._userInfo.langCode;
        window['appSettings'].Lang = this._userInfo.langCode;
        VueI18n.locale = this._userInfo.langCode;
        Quasar.lang.set(qLang.default);
        this.setApprovlas();
        this.setAdditionalJobs();
        this.setActingManagers();
        this.navigateUserByRole();
        this.openApprovalsDialog();
        this.displayMsgsInLogin();
        this.getCordovaVersion();
      })
  }

  setAdditionalJobs() {
    store.commit(AppConstants.StoreMutations.UpdateEmployeeAdditionalJobs, this.UserInfo.additionalJobs);
  }

  setActingManagers() {
    store.commit(AppConstants.StoreMutations.UpdateActingManagers, this.UserInfo.actingManagers);
  }

  setApprovlas() {
    store.commit(AppConstants.StoreMutations.UpdateHasApprovlas, this.UserInfo.approvals.hasApprovals);
    store.commit(AppConstants.StoreMutations.UpdateNoOfApprovals, this.UserInfo.approvals.noOfApprovals);
  }

  openApprovalsDialog() {
    if (this.UserInfo.approvals.hasApprovals && this.isAllowed(AppConstants.Permissions.PortalEmpSignOnAttendReportMandatory)) {
      this.isEmpApprovalsListDialogVisible = true;
    }

    if (this.UserInfo.isManager && this.UserInfo.approvals.hasManagerApprovals && this.isAllowed(AppConstants.Permissions.PortalMngrSignOnAttendReportMandatory)) {
      this.isManagerApprovalsListDialogVisible = true;
    }
  }

  displayMsgsInLogin() {
    this.isDisplayMsgsInLogin = true;
  }

  getCordovaVersion() {
    if (this.IsMobileApp) {
      window["cordova"].getAppVersion.getVersionNumber()
        .then(version => {
          this.cordovaVersionNo = version;
        }).catch(err => {
        })
    }
  }

  logOut() {
    this.appStorage.clearSession();
    this.Authenticated = false;

    let url = new URL(window.location.origin);
    url.searchParams.set("logout", "1");
    location.replace(url.href);
  }

  navigateUserByRole() {
    let currentRoute = router.currentRoute.path;
    let toRoute = null;

    let isPunchInOutOnly = this.isAllowed(AppConstants.Permissions.PortalPunchInOutOnly);
    if (isPunchInOutOnly) toRoute = "/punch_in_out";
    else if (this.UserInfo.isManager) toRoute = "/manager/employees"
    else toRoute = "/employee/personal_area";

    if (currentRoute == toRoute) return;
    this.navigate(toRoute);
  }

  isAllowed(permissionCode: string) {
    let permission = this._userInfo.permssions.find(
      s => s.code === permissionCode
    );
    return permission && permission.isAllow;
  }

  setShowHealthDeclaration(value: boolean) {
    this._userInfo.showHealthDeclaration = value;
  }

  initializeFireBase() {
    try {
      console.log("initializeFireBase");
      let fireBasePlugin = window["FirebasexMessaging"];

      if (this.IsAndroidDevice) {
        console.log("IsAndroidDevice");
        fireBasePlugin.getToken(token => {
          console.log("getToken");
          this.setFireBaseToken(fireBasePlugin, token);
        });
      } else {
        //IOS
        fireBasePlugin.grantPermission(data => {
          fireBasePlugin.getToken(token => {
            this.setFireBaseToken(fireBasePlugin, token);
          });
        });
      }
    } catch (error) {
      console.log("FIREBASE - ERROR:", error);
    }
  }

  private setFireBaseToken(fireBasePlugin, token) {
    console.log("token:", token);
    this.appStorage.persist("userMobileAppId", token);

    fireBasePlugin.subscribe("all");
    this.subscribeToPushNotificationEvents(fireBasePlugin);
  }

  private subscribeToPushNotificationEvents(fireBasePlugin) {
    // Handle token refresh
    fireBasePlugin.onTokenRefresh((token) => {
      console.log("onTokenRefresh:", token);
      this.appStorage.persist("userMobileAppId", token);
    });

    // Handle incoming notifications
    fireBasePlugin.onMessageReceived((notification) => {
    });
  }

  get IsMobileApp() {
    return this.device && (this.device.platform == "Android" || this.device.platform == "iOS");
  }

  get MobileAppUUID() {
    return this.IsMobileApp ? this.appStorage.persist("userMobileAppId", "§") : undefined;
  }

  get IsAndroidDevice() {
    return this.device && this.device.platform == "Android";
  }

  get UserInfo() {
    return this._userInfo;
  }

  get Headers() {
    return this._headers;
  }

  private get _headers() {
    return {
      "X-Requested-With": "Fetch",
      Accept: "application/json",
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json",
      currentlang: AppConstants.Lang.current,
      accesstoken: this._userInfo ? this._userInfo.accessToken : null,
      customercode: this.customerCode ? this.customerCode : ""
    };
  }

  get Authenticated() {
    return this._autenticated;
  }

  set Authenticated(v) {
    this._autenticated = v;
  }

  get isDevEnv() {
    return process.env.NODE_ENV == "development";
  }

  get isRtl() {
    return document.dir == "rtl";
  }
}

export class appStorage {
  private sharedState = {};
  shared(key, value: any = "§") {
    if (value === "§") {
      return this.sharedState[key];
    } else if (value === null) {
      delete this.sharedState[key];
    } else {
      this.sharedState[key] = value;
    }
    return null;
  }

  /** Session State **/
  session(key, value: any = "§") {
    if (window.sessionStorage) {
      if (value === "§") {
        return JSON.parse(
          window.sessionStorage.getItem(AppConstants.AppKey + ":" + key)
        );
      } else if (value === null) {
        window.sessionStorage.removeItem(AppConstants.AppKey + ":" + key);
      } else {
        window.sessionStorage.setItem(
          AppConstants.AppKey + ":" + key,
          JSON.stringify(value)
        );
      }
    }
    return null;
  }

  clearSession() {
    if (window.sessionStorage) window.sessionStorage.clear();
  }

  /** Persistent State **/
  persist(key, value: any = "§") {
    if (window.localStorage) {
      if (value === "§") {
        return JSON.parse(
          window.localStorage.getItem(AppConstants.AppKey + ":" + key)
        );
      } else if (value === null) {
        window.localStorage.removeItem(AppConstants.AppKey + ":" + key);
      } else {
        window.localStorage.setItem(
          AppConstants.AppKey + ":" + key,
          JSON.stringify(value)
        );
      }
    }
    return null;
  }
}
